import {
  extractHomeContentData,
  HomeLayoutProps,
} from "@app/layouts/Home/Elements/utils";
import { DataSource } from "@pub/config";

import FullWidthCarousel from "./FullWidthCarousel";

type Props = {
  data: HomeLayoutProps["data"];
  dataSource: DataSource;
  alternateBg?: boolean;
};

const HomeCarousel = ({ data, dataSource }: Props) => {
  const carouselData = extractHomeContentData(data, dataSource);
  if (!carouselData || carouselData.items.length === 0) {
    return null;
  }

  return (
    <FullWidthCarousel
      title={carouselData.title}
      titleUrl={carouselData.url}
      teasers={carouselData.items}
      backgroundImage={carouselData.backgroundImage}
      backgroundLogos={carouselData.backgroundLogos}
      backgroundColor={carouselData.config?.background}
      textColor={carouselData.config?.color}
    />
  );
};

export default HomeCarousel;
